import { createAction, createSlice } from "@reduxjs/toolkit";

export const getStoreData = createAction("store/getStoreData");

const storeDataSlice = createSlice({
  name: "storeData",
  initialState: {
    generations: [],
    enginesByGeneration: {},
    generationToModel: {},
    loading: false,
    error: null
  },
  reducers: {
    setStoreData: (state, action) => {
      state.generations = action.payload.generations;
      state.enginesByGeneration = action.payload.enginesByGeneration;
      state.generationToModel = action.payload.generationToModel;
      state.loading = false;
      state.error = null;
    },
    setStoreDataLoading: (state) => {
      state.loading = true;
      state.error = null;
    },
    setStoreDataError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    }
  }
});

export const {
  setStoreData,
  setStoreDataLoading,
  setStoreDataError
} = storeDataSlice.actions;

export default storeDataSlice.reducer;
